<template>
    <div class="row filter">
        <div class="tab col-md-12">
          <div class="filter-body">
            <div class="row">
              <div class="col-md-4 gray-bg">
                
                <span class="filter-span">Report</span>
                <vue-select id="report" key="report" :reset="reset" :locked="locked['reports']" :attributes="fields.reportAttributes" @changed="changed"></vue-select>
                
                <br>
                <span v-if="reportInfo && reportInfo['executionFrequency']" class="filter-span mar-top-15">Calcolato ogni: <b class="report-info">{{ reportInfo['executionFrequency'] | translate }}</b></span>
                
                <span v-if="reportInfo && reportInfo['lastExecution']" class="filter-span mar-top-15">Ultima esecuzione: <b class="report-info">{{ formatTimestamp(reportInfo['lastExecution']) }}</b></span>                
              </div>
              <div class="col-md-4 shadow">
                    <span class="filter-span  mar-top-15">Da</span>
                    <vue-datepicker id="report-lowerbound" :key="resetLowerBound" :reset="reset" :locked="locked['lowerbound']" :attributes="fields.lowerboundAttributes" @changed="changed"></vue-datepicker>
                    
                    <span class="filter-span  mar-top-15">A</span>
                    <vue-datepicker id="report-upperbound" :key="resetUpperBound" :reset="reset" :locked="locked['upperbound']" :attributes="fields.upperboundAttributes" @changed="changed"></vue-datepicker>
              </div>
              <div class="col md-4">
                <div class="filter-buttons">
                  <a class="button action light filters-btn" href="" @click.prevent="resetForm">reset</a>
                  <a class="button action dark filters-btn" href="" @click.prevent="exportData">esporta</a>
                  <a class="button action primary filters-btn" href="" @click.prevent="getData">genera</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <overlay :enabled="loading"></overlay>
    </div>
</template>

<script>
  import moment from 'moment'
  import notificator from '../../mixins/notificator';
  import { mapGetters } from 'vuex'

  import VueSelect from '@/components/Fields/Select.vue';
  import VueDatepicker from '@/components/Fields/Datepicker.vue';

  import Overlay from '@/components/Overlay.vue';

  export default {
    props: ['settings'],

    components: {VueSelect, VueDatepicker, Overlay},

    mixins: [notificator],

    data() {
      return {
        reports: [],
        reportInfo: {},
        loading: false,
        reset: null,
        resetLowerBound: 'lower-bound',
        resetUpperBound: 'upper-bound',
        ready: false,
        locked: {
          reports: true,
          lowerbound: true,
          upperbound: true,
        },

        fields: {
          reportAttributes: {},
          aggregationFrequencyAttributes: {},
          aggregationModeAttributes: {},
          lowerboundAttributes: {},
          upperboundAttributes: {}
        },              
      }
    },

    created() {
        //Report
        this.fields.reportAttributes = this.settings.reportAttributes;
        this.fields.reportAttributes['value']['value'] = this['selectedReport'];

        //Lowerbound
        this.fields.lowerboundAttributes = this.settings.lowerboundAttributes;
        this.fields.lowerboundAttributes['value']['value'] = this['selectedReportLowerbound'];
        
        //Upperbound
        this.fields.upperboundAttributes = this.settings.upperboundAttributes;
        this.fields.upperboundAttributes['value']['value'] = this['selectedReportUpperbound'];

        if(this['selectedReport']) {
            this.setBoundAttributes();
        }

        this.getClientReports();
    },

    mounted() {
      this.ready = true;
    },

    computed: {    
      ...mapGetters([
        'token',
        'clientId',
        'selectedSite',

        'selectedReport',
        'selectedReportLowerbound',
        'selectedReportUpperbound',
      ])
    },

    watch: {
      selectedReport() {        
        this.fields.reportAttributes['value']['value'] = this['selectedReport'];
      },
    },

    methods: {
        setBoundAttributes() {
            if(this.selectedReport == null) {
                this.locked['lowerbound'] = true;
                this.locked['upperbound'] = true;

            } else if(this.reportInfo != undefined){
                this.locked['lowerbound'] = false;
                this.locked['upperbound'] = false;

                var dateFormat = 'DD/MM/YYYY';
                switch (this.reportInfo['dataFrequency']) {
                    case 'minutely':
                        dateFormat = 'DD/MM/YYYY LT';
                    break;
                    case 'hourly':
                        dateFormat = 'DD/MM/YYYY LT';
                    break;
                    case 'daily':
                        dateFormat = 'DD/MM/YYYY';
                    break;
                    case 'monthly':
                        dateFormat = 'MM/YYYY';
                    break;
                    case 'yearly':
                        dateFormat = 'YYYY';
                    break;
                
                    default:
                        dateFormat = 'DD/MM/YYYY';
                    break;
                }

                this.settings.lowerboundAttributes['dateFormat']['value'] = dateFormat;
                this.settings.upperboundAttributes['dateFormat']['value'] = dateFormat;
            }

            this.fields.lowerboundAttributes['value']['value'] = null;
            this.fields.upperboundAttributes['value']['value'] = null;

            this.resetlowerAndUpperBound();
        },
        
      getClientReports() {
        this.overlay(true);

        this.$store
        .dispatch('getClientReports')
        .catch(error => {
            this.overlay(false);
            this.notify(this.$options.filters.notification({endpoint: 'GetClientReports', code: error}));            
        })
        .then(({data}) => {
            this.overlay(false);

            /*
            if (error.response.data.mispErrorDTO.code != undefined)
            reject(error.response.data.mispErrorDTO.code);
            else
            reject(null);
            */
            this.notify(this.$options.filters.notification({endpoint: 'GetClientReports', code: 200}));

            if(data.reports != undefined && data.reports.length > 0) {
              this.fields.reportAttributes.options.value = data.reports;
              this.reports = data.reports;

              this.locked.reports = false;
            } else {
              this.$emit('no-report-found');
            }
        });          
      },

      getId(string) {
        var tmp = string.split("-");

        var response = '';
        for (let index = 0; index < tmp.length; index++) {
          response += this.getFirstLetterUppercase(tmp[index]);            
        }
        return response;
      },

      getFirstLetterUppercase(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },

      changed(changed) {          
        var id = this.getId(changed.id);
        
        var value = null;
        
        if(changed.value != null && changed.value != '')
          value = changed.value;
        
        if('change' + id == 'changeReport') {
            this.$store.dispatch('change' + id, {value: value, info: changed.object});
            this.$set(this, 'reportInfo', changed.object);
            this.setBoundAttributes();
        } else {
            this.$store.dispatch('change' + id, value);
        }
      },
      
      generateRequest() {
        var offset = new Date().getTimezoneOffset();

        var request = {
            reportName: this.selectedReport, 
            clientId: this.clientId,
            sessionToken: this.token,
            fileFormat: 'CSV'
        };        

        switch (this.reportInfo['dataFrequency']) {
            case 'minutely': case 'hourly':
                // dateFormat = 'DD/MM/YYYY LT';
                var lower = this['selectedReportLowerbound'].split(" ");
                request['aqDatetimeLowerbound'] = moment(this['selectedReportLowerbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(lower[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';

                
                var upper = this['selectedReportUpperbound'].split(" ");
                request['aqDatetimeUpperbound'] = moment(this['selectedReportUpperbound'] + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment(upper[1], 'HH:mm').add(offset, 'minutes').format('HH:mm:ss') + 'Z';
            break;
            case 'daily':
                // dateFormat = 'DD/MM/YYYY';
                request['aqDatetimeLowerbound'] = moment(this['selectedReportLowerbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T00:00:00Z';
                request['aqDatetimeUpperbound'] = moment(this['selectedReportUpperbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T00:00:00Z';
            break;
            case 'monthly':
                // dateFormat = 'MM/YYYY';
                request['aqDatetimeLowerbound'] = moment('01/' + this['selectedReportLowerbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T00:00:00Z';
                request['aqDatetimeUpperbound'] = moment(this['selectedReportUpperbound'], 'MM/YYYY').endOf('month').add(offset, 'minutes').format('YYYY-MM-DD') + 'T00:00:00Z';                        
            break;
            case 'yearly':
                // dateFormat = 'YYYY';
                request['aqDatetimeLowerbound'] = moment('01/01/' + this['selectedReportLowerbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T00:00:00Z';
                request['aqDatetimeUpperbound'] = moment('31/12/' + this['selectedReportUpperbound'], 'DD/MM/YYYY').add(offset, 'minutes').format('YYYY-MM-DD') + 'T00:00:00Z';                        
            break;
        }

        return request;
    },

      validateFilter() {
        if(this['selectedReport'] == undefined || this['selectedReport'] == '' || this['selectedReport'] == null) {
          this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 606}));
          return false;
        }

        if(this['selectedReportUpperbound'] == undefined || this['selectedReportUpperbound'] == '' || this['selectedReportUpperbound'] == null) {
          this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 603}));
          return false;
        }
        
        if(this['selectedReportLowerbound'] == undefined || this['selectedReportLowerbound'] == '' || this['selectedReportLowerbound'] == null) {
          this.notify(this.$options.filters.notification({endpoint: 'ValidateFilter', code: 604}));
          return false;
        }
        
        return true;
      },
      
      exportData() {
        if(!this.ready || !this.validateFilter())
          return;
              
        this.overlay(true);

        this.$store
        .dispatch('getReportFile', {request: this.generateRequest()})
        .catch(error => {
            this.overlay(false);

            this.notify(this.$options.filters.notification({endpoint: 'GetReportFile', code: error}));
        })
        .then(({data}) => {
          this.overlay(false);

          this.notify(this.$options.filters.notification({endpoint: 'GetReportFile', code: 200}));
          
          if(data['reportUrl'] != undefined) {
            var win = window.open(data['reportUrl'], '_blank');
            win.focus();
          }
        });            
          
      },

      getData() {
        if(!this.ready || !this.validateFilter())
          return;

        //Emetto evento get report data
        this.$emit('get-report-data', {reportInfo: this.reportInfo});
      },

      overlay(action) {
          this.loading = action;
      }, 
      
        resetForm() {
            this.reset = (((1+Math.random())*0x10000)|0).toString(16).substring(1);

            this.locked['lowerbound'] = true;
            this.locked['upperbound'] = true;
        },

        resetlowerAndUpperBound() {
          this.resetLowerBound = (((1+Math.random())*0x10000)|0).toString(16).substring(1);
          this.resetUpperBound = (((1+Math.random())*0x10000)|0).toString(16).substring(1);
      },

      formatTimestamp(timestamp) {
          return moment(timestamp).format('DD/MM/YYYY HH:mm');
      }
    }
  }
</script>